import { render, staticRenderFns } from "./InstrumentInstanceDetail.vue?vue&type=template&id=7a961e2a"
import script from "./InstrumentInstanceDetail.vue?vue&type=script&lang=js"
export * from "./InstrumentInstanceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports